import { processCorrelations } from "@/_core/data/api_calls/relatives_values/correlations/processCorrelations";

/**
 * Retrieves correlation data for currencies relative values
 * @param {object} ctx: context variables
 * @param {object} assetExtraParams: extra parameters for query
 */
export async function getCommodityCorrelations(ctx, assetExtraParams) {
  let params = {
    method: "GET",
    endpoint: "relatives_values_historical_commodities",
    content_type: "application/json",
    query_params: {
      format: "json",
      commodity: assetExtraParams.commodityNumber,
      contract: assetExtraParams.contract,
      correlations: true
    }
  };
  return processCorrelations(ctx, params);
}
